<div class="d-block complementary-services-container">
  <div class="row justify-content-evenly">
    <app-complementary-service-item class="col-sm-4 col-12" *ngFor="let complementaryService of complementaryServices; trackBy:identify" [complementaryService]="complementaryService">
    </app-complementary-service-item>
  </div>
</div>
